import { render, staticRenderFns } from "./dataFormSubsidiary3.vue?vue&type=template&id=2e325e58&scoped=true"
import script from "./dataFormSubsidiary3.vue?vue&type=script&lang=js"
export * from "./dataFormSubsidiary3.vue?vue&type=script&lang=js"
import style0 from "./dataFormSubsidiary3.vue?vue&type=style&index=0&id=2e325e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e325e58",
  null
  
)

export default component.exports